<ol class="c-applicant-list">
  <li>
    <div class="c-applicant-list__item">
      <span class="c-applicant-list__detail">
        <span class="c-applicant-list__name">{{incomeDisplayName}}</span>
        @if (isIncomeSaved) {
          <button class="c-applicant-list__action c-button" type="button" aria-controls="exampleEpandedContent1" aria-expanded="true" (click)="toggleDeleteDialogEnabled()">Remove</button>
        }
        <button (click)="toggleIncomeDetailEnabled()" class="c-applicant-list__action c-button c-button--icon-drop" type="button">
          <span class="visually-hidden">Open detail</span>
          @if (!isIncomeDetailEnabled) {
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"  viewBox="0 0 29 19">
              <rect id="backgroundrect" width="100%" height="100%" x="0" y="0" fill="none" stroke="none"/>
              <g class="currentLayer">
                <path fill="none" stroke="#3f2b56" stroke-width="7" d="M25.5 3.5l-11 12-11-12" stroke-linecap="round" stroke-linejoin="round" id="svg_1" class="" transform="rotate(-0.6902841329574585 14.499999999999808,9.499999999999968) "/>
              </g>
            </svg>
          }
          @if (isIncomeDetailEnabled) {
            <svg class="c-button__icon icon-drop" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" viewBox="0 0 29 19">
              <rect id="backgroundrect" width="100%" height="100%" x="0" y="0" fill="none" stroke="none"/>
              <g class="currentLayer">
                <path fill="none" stroke="#3f2b56" stroke-width="7" d="M25.5 3.5l-11 12-11-12" stroke-linecap="round" stroke-linejoin="round" id="svg_1" class="" transform="rotate(-179.99998474121094 14.5,9.5) "/>
              </g>
            </svg>
          }
        </button>
      </span>
    </div>
  </li>
  @if (isDeleteDialogVisible) {
    <div class="c-applicant-list__expanded is-active" aria-hidden="false">
      <div class="c-applicant-list__expanded-body">
        <p>
          <strong>Are you sure you want to remove this income for this applicant?</strong>
        </p>
        <p>This data cannot be retrieved once deleted.</p>
      </div>
      <button class="c-button c-button--input-brand" type="button" (click)="deleteIncome()">Yes, I'm sure</button>
      <button class="c-button c-button--input" type="button" (click)="toggleDeleteDialogEnabled()">No, don't remove</button>
    </div>
  }
</ol>
@if (isIncomeDetailEnabled) {
  <div class="applicant-container">
    <form [formGroup]="tadIncomeForm">
      <div class="row">
        <div class="col">
          <strong>Choose an income type or employment status</strong>
          <p class="lead mb-0"><small>You can save and add multiple income types</small></p>
        </div>
      </div>
      <div class="row">
        <div class="col col-md-7 col-lg-6"
            [ngClass]="{'is-invalid': tadIncomeForm.get('tadEmploymentType').touched &&
             tadIncomeForm.get('tadEmploymentType').invalid}">
          <income-type [(incomeType)]="tadEmploymentTypeSetter"
            [isInvestmentExist] = "isInvestmentExist"
            [isRentalExist] = "isRentalExist"
                [invalid]="tadIncomeForm.get('tadEmploymentType').touched && 
                tadIncomeForm.get('tadEmploymentType').hasError('required')"></income-type>
        </div>
      </div>
      @if (tadIncomeForm.get('tadEmploymentType').value !== '6') {
        @if (showIncome) {
          <div class="form-group mt-2">
            <label for="examplePound">What is your <b>{{incomeLabelType}} {{incomeLabel}}</b> income?</label>
            <div class="row">
              <div class="col col-md-6">
                <div class="form-group c-input--pound mb-0" [ngClass]="{'is-invalid': tadIncomeForm.get('tadIncomeBeforeTax').touched && tadIncomeForm.get('tadIncomeBeforeTax').invalid, 'is-valid': tadIncomeForm.get('tadIncomeBeforeTax').touched && tadIncomeForm.get('tadIncomeBeforeTax').valid}">
                  <div class="d-flex">
                    <div class="mr-2 w-100">
                      <div class="input-group">
                        <span class="input-group-addon" id="pound-addon">&pound;</span>
                        <input type="number" class="form-control" formControlName="tadIncomeBeforeTax" [ngClass]="{'is-invalid': tadIncomeForm.get('tadIncomeBeforeTax').touched && tadIncomeForm.get('tadIncomeBeforeTax').invalid, 'is-valid': tadIncomeForm.get('tadIncomeBeforeTax').touched && tadIncomeForm.get('tadIncomeBeforeTax').valid}"
                          aria-describedby="pound-addon" id="examplePound">
                        </div>
                      </div>
                      <div>
                        <together-auction-dip-tooltip [placement]="'top'" [title]="'Net income is your take home pay after all costs such as taxes, pensions and other expenses, have been deducted from your gross income.'"></together-auction-dip-tooltip>
                      </div>
                    </div>
                  </div>
                  <together-auction-dip-validate-fields [displayError]="tadIncomeForm.get('tadIncomeBeforeTax').touched && tadIncomeForm.get('tadIncomeBeforeTax').hasError('required')" errorMsg="We need an income."></together-auction-dip-validate-fields>
                  <together-auction-dip-validate-fields [displayError]="tadIncomeForm.get('tadIncomeBeforeTax').touched && tadIncomeForm.get('tadIncomeBeforeTax').hasError('hasDecimalPoint')" errorMsg="Please enter a valid income."></together-auction-dip-validate-fields>
                </div>
              </div>
            </div>
          }
        }
        @if (tadIncomeForm.get('tadEmploymentType').value === '3' || tadIncomeForm.get('tadEmploymentType').value === 3) {
          <fieldset>
            <div class="row">
              <div class="col col-md-7 col-lg-6">
                <self-employment-type [(selfEmploymentType)]="selfEmploymentTypeSetter"></self-employment-type>
              </div>
            </div>
            <div class="form-group" [ngClass]="{'is-invalid': tadIncomeForm.get('tadCompanyName').touched && tadIncomeForm.get('tadCompanyName').invalid, 'is-valid': tadIncomeForm.get('tadCompanyName').touched && tadIncomeForm.get('tadCompanyName').valid}">
              <div class="row">
                <div class="col col-md-6">
                  <label for="tadCompanyName">Company name</label>
                  <input class="form-control" formControlName="tadCompanyName" [ngClass]="{'is-invalid': tadIncomeForm.get('tadCompanyName').touched && tadIncomeForm.get('tadCompanyName').invalid, 'is-valid': tadIncomeForm.get('tadCompanyName').touched && tadIncomeForm.get('tadCompanyName').valid}"
                    type="text" name="tadCompanyName">
                  </div>
                </div>
              </div>
            </fieldset>
            <together-auction-dip-validate-fields [displayError]="tadIncomeForm.get('tadCompanyName').touched && tadIncomeForm.get('tadCompanyName').hasError('required')" errorMsg="Please enter the name of the company as it appears in Companies House."></together-auction-dip-validate-fields>
          }
        </form>
      </div>
    }
